export const combineTransByInvestName = (buyTransArr) => {
    // this process combines the buy/sell summary transactions by investShortName
            
    let prevShortName = "";
    let prevTran = {};
    let buyTranSummaryArr = [];
    let totalInitialPrice = 0;
    let totalCurrentPrice = 0;
    let totalGainLoss = 0;
    let totalQuantity = 0;
    for (let i=0; i< buyTransArr.length; i++){
        const buyTran = buyTransArr[i];
        if (buyTran.investShortName !== prevShortName){
            if (prevShortName !== ""){
                const summaryArrObj = {...prevTran, investShortName: prevShortName,
                    quantity: totalQuantity, totalInitialPrice: totalInitialPrice,
                    totalCurrentPrice: totalCurrentPrice, totalGainLoss: totalGainLoss
                }
                buyTranSummaryArr.push(summaryArrObj);
            }
            prevTran = {classification: buyTran.classification, imageUrl: buyTran.imageUrl,
                investmentName: buyTran.investmentName, symbol: buyTran.symbol, 
                transactionDate: buyTran.transactionDate
            }
            prevShortName = buyTran.investShortName;
            totalInitialPrice = 0;
            totalCurrentPrice = 0;
            totalGainLoss = 0;
            totalQuantity = 0;
        }
        totalQuantity += +buyTran.quantity;
        totalInitialPrice += +buyTran.totalInitialPrice;
        totalCurrentPrice += +buyTran.totalCurrentPrice;
        totalGainLoss += +buyTran.totalGainLoss;
    }
    if (prevShortName !== ""){
        const summaryArrObj = {...prevTran, investShortName: prevShortName,
            quantity: totalQuantity, totalInitialPrice: totalInitialPrice,
            totalCurrentPrice: totalCurrentPrice, totalGainLoss: totalGainLoss }
        buyTranSummaryArr.push(summaryArrObj);
    }
       
    
    return buyTranSummaryArr;
} 

export default combineTransByInvestName;